import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Certificate } from './certificate.interface';
import { CertificateService } from './certificate.service';

const service = new CertificateService();

export interface CertificateState {
   certificates: Array<Certificate>;
}

const CertificateStore: Module<CertificateState, StoreState> = {
   namespaced: true,
   state: {
      certificates: [],
   },
   getters: {
      certificates: (state) => state.certificates,
   },
   mutations: {
      SET_CERTIFICATES(state, certificates: Array<Certificate>) {
         state.certificates = certificates;
      },
   },
   actions: {
      async getCertificates(context, query: LocationQuery) {
         const response = await service.getCertificates({ ...query, per_page: '9999', page: '1', include: 'country' });
         context.commit('SET_CERTIFICATES', response.data);
         return response.data;
      },
   },
};

export default CertificateStore;
